<template>
    <div>
        <div class="content-box">
            <p>{{info}}</p>
            <div class="maxerrorheight">
                <p v-for="(item, index) in list" :key="index">{{ item }}</p>
            </div>
        </div>
        <p class="dialog-footer tac mt20" v-if="type === 'special_char'">
            <el-button type="default" @click="hideModal" class="action-btn mr20">关闭</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">一健去除并提交</el-button>
        </p>
    </div>
</template>

<!-- 小米批量 失败 弹框-->
<script>
import API from '@/api/marketManage/miBatchAuto.js';
export default {
    name: "resultModal",
    props:['cbs', 'id', 'info', 'list', 'type'],
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.fetchBatchPass()
        },
        hideModal(){
            this.$emit('close');
        },
        //批量选中
        fetchBatchPass() {
            API.postDelSpecialCharacter({task_id:this.id}).then(res=>{
                this.cbs.onSubmit()
            },err=>{
                this.$message.error(err.info)
            })
        },
    }
}
</script>

<style scoped lang="scss">
.maxerrorheight{
    max-height: calc(100vh - 400px);
    padding-top: 20px;
    overflow-y: auto;
}
</style>
